import ClientsGrid from '../../components/grids/ClientsGrid';
import AddClientForm from '../../components/FormComps/Clients/AddClientForm';
import EditClientForm from '../../components/FormComps/Clients/EditClientForm';

import { useState, useEffect, createRef } from 'react';
import { useToast } from '../../contexts/ToastContext';

import { Drawer, DrawerContent, DrawerNavigation, TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { FaFileAlt, FaFileCsv, FaFileImage, FaFilePdf, FaTimesCircle } from 'react-icons/fa';
import { submitClient, updateClient, deleteClient, exportClients, getClientDocuments } from '../../data/clientData';
import { clientsGrid, fileDocumentTypes } from '../../data/interfaces';
import { getClients } from '../../data/clientData';

import '../Styles.css';
import { ExternalDropZone, Upload, UploadFileInfo, UploadListItemProps, UploadOnStatusChangeEvent } from '@progress/kendo-react-upload';
import QuoteDocumentRow from '../../components/QuoteDocumentRow';
import { deleteDocument } from '../../data/fileData';

const Clients = () => {
    const [clientData, setClientData] = useState<clientsGrid[]>([]);
    const [expanded, setExpanded] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [addFormVisible, setAddFormVisible] = useState(false);
    const [clientId, setClientId] = useState(0);
    const { showToast } = useToast();
    const uploadRef = createRef<Upload>();
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [files, setFiles] = useState<UploadFileInfo[]>([])
    const token = localStorage.getItem('authToken');
    const [documentData, setDocumentData] = useState<fileDocumentTypes[]>([
        {
          documentId: 0,
          fileName: '',
          fileExtension: '',
          appCanView: false,
        },
      ]);
      const apiURL = process.env.REACT_APP_API_URL;





    const [showDeleted, setShowDeleted] = useState(false);

    const handleRejected = (value: boolean) => {
        setShowDeleted(value);
    }

    const handleSelectedTab = (e: TabStripSelectEventArguments) => {
        setSelectedTab(e.selected)
      }

    const handleAddForm = () => {
        setAddFormVisible((prevState) => (!prevState ? true : true));
        setEditFormVisible(false);
        handleExpanded();
    };

    const handleEditForm = (id: number) => {
        console.log('id: ', id)
        setClientId(id);
        setEditFormVisible((prevState) => (!prevState ? true : true));
        setAddFormVisible(false);
        handleExpanded();
    };

    const updateClientHandler = (dataItem: any, id: number) => {
        const clientObj = {
          openJobs: dataItem.openJobs,
           openEnquiries: dataItem.openEnquiries,
           openQuotes: dataItem.openQuotes,
            clientId: id,
            clientName: dataItem.clientName,
            accountRef: dataItem.accountRef,
            contactName: dataItem.contactFirstName + ' ' + dataItem.contactLastName,
            phone: dataItem.phone,
            email: dataItem.email,
            clientAddr: dataItem.clientAddr,
            postcode: dataItem.postcode,
            phone2: dataItem.phone2,
            fax: dataItem.fax,
            tradeContact: dataItem.tradeContact,
            email2: dataItem.email2,
            email3: dataItem.email3,
            websiteUrl: dataItem.websiteUrl,
            vatNum: dataItem.vatNum,
            directdebitEmail: dataItem.directdebitEmail,
            defaultAdjustment: dataItem.defaultAdjustment ?? 0,
        };
        updateClient(clientObj, id).then(() => {
            const fetchData = async () => {
                const clientData = await getClients(showDeleted);
                setClientData(clientData);
            };
            fetchData();
        });
        handleExpanded();
        showToast('Client succesfully updated', 'success');
    };

    const newClientHandler = (dataItem: any) => {
        const clientObj = {
            clientName: dataItem.clientName,
            accountRef: dataItem.accountRef,
            contactName: dataItem.contactFirstName + ' ' + dataItem.contactLastName,
            phone: dataItem.phone,
            email: dataItem.email ? dataItem.email : null,
            clientAddr: dataItem.clientAddr,
            postcode: dataItem.postcode,
            phone2: dataItem.phone2 ? dataItem.phone2 : null,
            fax: dataItem.fax ? dataItem.fax : null,
            tradeContact: dataItem.tradeContact ? dataItem.tradeContact : null,
            email2: dataItem.email2 ? dataItem.email2 : null,
            email3: dataItem.email3 ? dataItem.email3 : null,
            websiteUrl: dataItem.websiteUrl ? dataItem.websiteUrl : null,
            vatNum: dataItem.vatNum ? dataItem.vatNum : null,
            directdebitEmail: dataItem.directdebitEmail ? dataItem.directdebitEmail : null,
        };
        console.log(clientObj);
        submitClient(clientObj).then(() => {
            const fetchData = async () => {
                const clientData = await getClients(showDeleted);
                setClientData(clientData);
            };
            fetchData();
        });
        handleExpanded();
        showToast('Client succesfully added', 'success');
    };

    const deleteClientHandler = (id: number) => {
        deleteClient(id);
        setClientData(clientData.filter((client: any) => client.clientId !== id));
        handleExpanded();
        showToast('Client succesfully deleted', 'success');
    };

    useEffect(() => {
        const fetchData = async () => {
            const clientsData = await getClients(showDeleted);
            setClientData(clientsData);
        };

        fetchData();
    }, [showDeleted]);

    const exportClientsHandler = () => {
        exportClients();
    };

    const handleExpanded = () => {
        setExpanded((prevState) => !prevState);

        if (editFormVisible) {
            setEditFormVisible(false)
        }
        if (addFormVisible) {
            setAddFormVisible(false)
        }
    };

    const handleSelect = () => {
        setExpanded(false);
    };

    const icon = (fileName: string) => {
        if (fileName.includes('.pdf')) {
          return (
            <FaFilePdf
              style={{
                fontSize: '20pt',
                color: 'rgb(33, 67, 59)',
                marginRight: '1rem',
              }}
            />
          )
        } else if (fileName.includes('.csv')) {
          return (
            <FaFileCsv
              style={{
                fontSize: '20pt',
                color: 'rgb(33, 67, 59)',
                marginRight: '1rem',
              }}
            />
          )
        } else if (fileName.includes('.txt')) {
          return (
            <FaFileAlt
              style={{
                fontSize: '20pt',
                color: 'rgb(33, 67, 59)',
                marginRight: '1rem',
              }}
            />
          )
        } else if (fileName.includes('.jpg')) {
          return (
            <FaFileImage
              style={{
                fontSize: '20pt',
                color: 'rgb(33, 67, 59)',
                marginRight: '1rem',
              }}
            />
          )
        } else if (fileName.includes('.png')) {
          return (
            <FaFileImage
              style={{
                fontSize: '20pt',
                color: 'rgb(33, 67, 59)',
                marginRight: '1rem',
              }}
            />
          )
        } else {
          return (
            <FaFileAlt
              style={{
                fontSize: '20pt',
                color: 'rgb(33, 67, 59)',
                marginRight: '1rem',
              }}
            />
          )
        }
      }

      const handleUploadSuccess = (event: UploadOnStatusChangeEvent) => {
        setFiles(event.newState)
        showToast('Succesfully uploaded new document', 'success')
        console.log('files: ', files)
      }      
      

    const CustomListItemUI = (props: UploadListItemProps) => {
        return (
          <ul>
            {props.files.map((file) => (
              <div
                style={{ fontSize: '10pt', fontFamily: 'Heebo, Sans-Serif' }}
                key={file.name}
              >
                {icon(file.name)}
                {file.name}
              </div>
            ))}
          </ul>
        )
      }    

      useEffect(() => {
        const fetchDocumentData = async () => {
          const documentData = await getClientDocuments(clientId)
          setDocumentData(documentData)
        }
    
        fetchDocumentData()
      }, [files, clientId])

      const handleDocumentDelete = async (documentId: number) => {
        await deleteDocument(documentId)
        setDocumentData(
          documentData.filter((document: any) => document.documentId !== documentId)
        )
      }      

    return (
        <div>
            <Drawer
                expanded={expanded}
                position={'end'}
                width={750}
                mode="overlay"
                animation={{
                    duration: 400,
                }}
                onOverlayClick={handleExpanded}
                onSelect={handleSelect}
            >
                <DrawerContent>
                    <DrawerNavigation>
                        {addFormVisible && (
                            <>
                                <div className="form__title__container">
                                    <h1 className="form__title">Add Client</h1>
                                    <FaTimesCircle className="closeform" onClick={handleExpanded} />
                                </div>
                                <div className="form__wrapper">
                                    <AddClientForm
                                        onClientSubmit={newClientHandler}
                                    />
                                </div>
                            </>
                        )}

                        {editFormVisible && (
                            <>
                                <div className="form__title__container">
                                    <h1 className="form__title">Edit Client</h1>
                                    <FaTimesCircle className="closeform" onClick={handleExpanded} />
                                </div>
                                <TabStrip
                                    selected={selectedTab}
                                    onSelect={handleSelectedTab}
                                    className='form__tabstrip__container'
                                >
                                <TabStripTab title="Edit Customer">
                                        <EditClientForm
                                            onEditSubmit={updateClientHandler}
                                            onClientId={clientId}
                                            onClientDelete={deleteClientHandler}
                                        />
                                    </TabStripTab>
                                    <TabStripTab title='Files'>
                                        <ExternalDropZone
                                            style={{ fontSize: '10pt', fontFamily: 'Heebo, sans-serif' }}
                                            uploadRef={uploadRef}
                                        />
                                        <div style={{ height: '20px' }} />
                                        <Upload
                                            ref={uploadRef}
                                            batch={true}
                                            files={files}
                                            multiple={true}
                                            defaultFiles={[]}
                                            withCredentials={false}
                                            listItemUI={CustomListItemUI}
                                            saveHeaders={{ Authorization: `Bearer ${token}` }}
                                            saveUrl={token ? `https://${apiURL}/Files/Client/${clientId}` : ''}
                                            onStatusChange={handleUploadSuccess}
                                        />

                                        <div style={{ height: '1.5rem' }} />

                                        <div>
                                            {documentData.length > 0 ? (
                                                <div>
                                                    {documentData.map((document: fileDocumentTypes) => (
                                                        <QuoteDocumentRow
                                                            key={document.documentId}
                                                            onDocumentId={document.documentId}
                                                            onFileName={document.fileName}
                                                            onFileExtension={document.fileExtension}
                                                            onDocumentDelete={handleDocumentDelete}
                                                        />
                                                    ))}
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        width: '100%',
                                                        padding: '1rem',
                                                        backgroundColor: 'rgb(216 229 237)',
                                                        borderRadius: '0.5rem',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <p style={{ margin: 0 }}>No files uploaded yet</p>
                                                </div>
                                            )}
                                        </div>
                                    </TabStripTab>

                                </TabStrip>

                            </>
                        )}
                    </DrawerNavigation>

                    <ClientsGrid
                        onAddToggle={handleAddForm}
                        onExport={exportClientsHandler}
                        onEditToggle={handleEditForm}
                        onData={clientData}
                        onShowDeleted={handleRejected}
                    />
                </DrawerContent>
            </Drawer>
        </div>
    );
};

export default Clients;
